import { TreeDesignTokens } from '@primeuix/themes/types/tree';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tDeep, t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/tree/index.ts
const tr = componentCommon.tree;
const d = tDeep(tr);

export const TreeTelekomDT: TreeDesignTokens = {
  root: {
    background: t(tr.background),
    color: t(tr.color),
    padding: t(tr.padding),
    gap: t(tr.gap),
    indent: t(tr.indent),
  },
  node: {
    padding: `${d.node.padding.y} ${d.node.padding.x}`,
    borderRadius: t(tr.node.border.radius),
    hoverBackground: t(tr.node.hover.background),
    selectedBackground: t(tr.node.selected.background),
    color: t(tr.node.color),
    hoverColor: t(tr.node.hover.color),
    selectedColor: t(tr.node.selected.color),
    gap: t(tr.node.gap),
    focusRing: {
      width: t(tr.node.focus.ring.width),
      offset: t(tr.node.focus.ring.offset),
      color: t(tr.node.focus.ring.color),
    },
  },
  nodeIcon: {
    color: t(tr.node.icon.color),
    hoverColor: t(tr.node.icon.hover.color),
    selectedColor: t(tr.node.icon.selected.color),
  },
  nodeToggleButton: {
    borderRadius: t(tr.node.toggle.button.border.radius),
    size: t(tr.node.toggle.button.size),
    hoverBackground: t(tr.node.toggle.button.hover.background),
    selectedHoverBackground: t(tr.node.toggle.button.selected.hover.background),
    color: t(tr.node.toggle.button.color),
    hoverColor: t(tr.node.toggle.button.hover.color),
    selectedHoverColor: t(tr.node.toggle.button.selected.hover.color),
    focusRing: {
      width: t(tr.node.toggle.button.focus.ring.width),
      offset: t(tr.node.toggle.button.focus.ring.offset),
      color: t(tr.node.toggle.button.focus.ring.color),
    },
  },
  loadingIcon: {
    size: t(tr.loading.icon.size),
  },
  filter: {
    margin: t(tr.filter.margin),
  },
};
